// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2YkIH","colCheckbox":"styles_colCheckbox__EFto-"};